<template>
   <span>
      <span @click="startConfirmingPassword">
         <slot />
      </span>
      <jet-dialog-modal :show="confirmingPassword" @close="confirmingPassword = false">
         <template #title>
            {{ title }}
         </template>

         <template #content>
            {{ content }}

            <div class="mt-4">
               <jet-input type="password" class="mt-1 block w-3/4" placeholder="Password"
                           ref="password"
                           v-model="form.password"
                           @keyup.enter.native="confirmPassword" />

               <jet-input-error :message="form.error" class="mt-2" />
            </div>
         </template>

         <template #footer>
            <jet-secondary-button @click.native="confirmingPassword = false">
               Nevermind
            </jet-secondary-button>

            <jet-button class="ml-2 primary" @click.native="confirmPassword" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
               <div class="text-white">{{ button }}</div>
            </jet-button>
         </template>
      </jet-dialog-modal>
   </span>
</template>

<script>
import JetButton from './Button'
import JetDialogModal from './DialogModal'
import JetInput from './Input'
import JetInputError from './InputError'
import JetSecondaryButton from './SecondaryButton'

export default {
   props: {
      title: {
         default: 'Confirm Password',
      },
      content: {
         default: 'For your security, please confirm your password to continue.',
      },
      button: {
         default: 'Confirm',
      }
   },

   components: {
      JetButton,
      JetDialogModal,
      JetInput,
      JetInputError,
      JetSecondaryButton,
   },

   data() {
      return {
         confirmingPassword: false,

         form: this.$inertia.form({
            password: '',
            error: '',
         }, {
            bag: 'confirmPassword',
         })
      }
   },

   methods: {
      startConfirmingPassword() {
         this.form.error = '';

         axios.get(route('password.confirmation').url()).then(response => {
            if (response.data.confirmed) {
               this.$emit('confirmed');
            } else {
               this.confirmingPassword = true;
               this.form.password = '';

               setTimeout(() => {
                  this.$refs.password.focus()
                  console.log(this.$refs.password)
               }, 250)
            }
         })
      },

      confirmPassword() {
         this.form.processing = true;

         axios.post(route('password.confirm').url(), {
            password: this.form.password,
         }).then(response => {
            this.confirmingPassword = false;
            this.form.password = '';
            this.form.error = '';
            this.form.processing = false;

            this.$nextTick(() => this.$emit('confirmed'));
         }).catch(error => {
            console.log(error)
            this.form.processing = false;
            this.form.error = error.response.data.errors.password[0];
         });
      }
   }
}
</script>
